export const downloadFile = (response, fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') => {
    try {
        const url = response.data.payload.filename;
        const filename = url.split("/").pop();

        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        link.style.display = "none";

        document.body.appendChild(link);
        link.click();
    } catch (error) {
        console.error('Error downloading file:', error);
        throw error;
    }
};
